import React from "react";
import SessionsHistory from "./sessions-history";

class SessionsHistoryController extends React.Component{

    render(){
        return <SessionsHistory {...this.props} />
    }
}

export default SessionsHistoryController;